import { render, staticRenderFns } from "./ImageGridPublicDisplayItem.vue?vue&type=template&id=a8daddde&scoped=true"
import script from "./ImageGridPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./ImageGridPublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./ImageGridPublicDisplayItem.vue?vue&type=style&index=0&id=a8daddde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8daddde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8daddde')) {
      api.createRecord('a8daddde', component.options)
    } else {
      api.reload('a8daddde', component.options)
    }
    module.hot.accept("./ImageGridPublicDisplayItem.vue?vue&type=template&id=a8daddde&scoped=true", function () {
      api.rerender('a8daddde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/ImageGridPublicDisplayItem.vue"
export default component.exports